export default "__VITE_ASSET__a44b8f4e__"